module.exports = __webpack_public_path__ + "static/media/logoprocut.c2fa08fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/logoprocut.png
// module id = 385
// module chunks = 6